<div class="flex flex-col gap-0.5">
    <div class="flex flex-col gap-2 items-baseline">
        @if (label()) {
            <label
                class="font-normal text-base"
                [for]="inputId"
                [matTooltip]="labelTooltip()"
                [matTooltipDisabled]="!labelTooltip()"
                >{{ label() }}</label
            >
        }

        @if (errors().length) {
            @for (error of errors(); track error) {
                <span class="text-error text-xs">
                    {{ error | transloco }}
                </span>
            }
        }
    </div>

    @if (inputFormControl()) {
        <input
            class="!rounded-lg"
            type="text"
            [class]="additionalClasses()"
            [class.border-error]="errors().length"
            [class.border-none]="!errors().length"
            [class.disabled]="disabled()"
            [formControl]="inputFormControl()!"
            [id]="inputId"
            [matTooltip]="valueTooltip()"
            [matTooltipDisabled]="!valueTooltip()"
            [placeholder]="placeholder()"
            [readonly]="disabled()"
            (blur)="handleOnBlur()"
            (input)="onChange($event)" />
    } @else {
        <input
            class="!rounded-lg"
            type="text"
            [class]="additionalClasses()"
            [class.border-error]="errors().length"
            [class.border-none]="!errors().length"
            [class.disabled]="disabled()"
            [disabled]="disabled()"
            [id]="inputId"
            [matTooltip]="valueTooltip()"
            [matTooltipDisabled]="!valueTooltip()"
            [placeholder]="placeholder() ?? 'enterText' | transloco"
            [readonly]="disabled()"
            (blur)="handleOnBlur()"
            (input)="onChange($event)" />
    }
</div>
